import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import { Button, Table } from "react-bootstrap";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterPannel from "../../filter/FilterPannel";
import moment from 'moment';

class LeadStatusBySalesPerson extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model);

    const userOptions = model.user.options.filter(
      (option) =>
        option.status === Constants.Active || option.status === Constants.AlwaysActive
    ) || [];

    const statusOptions = model.lead.fields.progress.options || [];

    this.fields = model.lead.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;

    this.state = {
      progressData: [],
      statusOptions,
      userOptions,
      filters: [
        {
          field: "enquiry_date",
          condition: "in",
          value: `${moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')}~${moment()
            .endOf('month')
            .format('YYYY-MM-DD HH:mm:ss')}`,
        },
      ],
      tableData: [],
      series: [],
      inApiCall: false,
      isFilterOpen: false,
      exportData: [],
    };
  }

  componentDidMount() {
    this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
  }

  fetchApi = (filters, onSuccess, onFail) => {
    const body = {
      filters: filters,
      model: "lead_model",
      x: "progress", // now status/progress
      y: "responsible_person",
      z: "COUNT(id)",
    };
    this.setState({ inApiCall: true });
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };

  parseData = (response) => {
    let selectedUserId;
    this.state.filters.map((filter) =>
      filter.field === "responsible_person"
        ? (selectedUserId = filter.value.split(Constants.Opt).filter(Boolean))
        : null
    );

    const filteredUserOptions = this.state.userOptions.filter((user) => {
      if (Boolean(selectedUserId)) {
        return selectedUserId.some((id) => parseInt(id) === user.value);
      }
      return true;
    });

    // Prepare table data
    const tableData = filteredUserOptions.map((person) => {
      const row = { salesperson: person.label, total: 0 };
      this.state.statusOptions.forEach((status) => {
        const totalSum = response
          .filter(
            (item) =>
              item.responsible_person.includes(`~${person.value}~`) &&
              item.progress === status.value
          )
          .reduce((sum, item) => sum + (item.sum || 0), 0);
        row[status.label] = totalSum;
        row.total += totalSum;
      });
      return row;
    });

    // Add total row
    const totalRow = { salesperson: "Total", total: 0 };
    this.state.statusOptions.forEach((status) => {
      const colTotal = tableData.reduce((sum, row) => sum + row[status.label], 0);
      totalRow[status.label] = colTotal;
      totalRow.total += colTotal;
    });

    tableData.push(totalRow);

    // Prepare chart series
    const series = this.state.statusOptions.map((status) => ({
      name: status.label,
      data: filteredUserOptions.map((person) => {
        const totalSum = response
          .filter(
            (item) =>
              item.responsible_person.includes(`~${person.value}~`) &&
              item.progress === status.value
          )
          .reduce((sum, item) => sum + (item.sum || 0), 0);
        return totalSum;
      }),
    }));

    return { tableData, series };
  };

  onSuccess = (data) => {
    const { tableData, series } = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData, series, exportData, inApiCall: false });
  };

  onFail = (err) => {
    console.log("Failed to fetch data", err);
    this.setState({ inApiCall: false });
  };

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters }, () =>
      this.fetchApi(this.state.filters, this.onSuccess, this.onFail)
    );
  };

  render() {
    const { exportData, filters, isFilterOpen, inApiCall, statusOptions, tableData, userOptions, series } =
      this.state;

    const table = (
      <Table bordered hover striped responsive>
        <thead>
          <tr>
            <th>Salesperson</th>
            <th>Total</th>
            {statusOptions.map((status, idx) => (
              <th key={idx}>{status.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td>{row.salesperson}</td>
              <td>{row.total}</td>
              {statusOptions.map((status, idx) => (
                <td key={idx}>{row[status.label]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h1>Lead Status by Sales Person</h1>
                </div>
                <div className="col-md-6">
                  <CSVLink
                    data={exportData}
                    filename={`lead_By_salesperson_By_status_report.csv`}
                  >
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div
                      className="btn btn-lead btn-sm filter-button"
                      onClick={this.toggleFilter}
                    >
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
             <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                    {/* Table on top */}
                <div className="col-md-12">{table}</div>
                {/* Chart with a title */}
                <div className="col-md-12">
                    <h4 className="mt-4 mb-3">Lead Status By Sales Person Chart</h4>
                    <StackedChartComponent
                    progressOptions={userOptions}
                    progressSums={series}
                    type={"multiBar"}
                    />
                </div>
                </div>

                {isFilterOpen && (
                  <FilterPannel
                    filters={filters}
                    fields={this.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={isFilterOpen}
                    restrict={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default LeadStatusBySalesPerson;
